import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top";
import Slider from '../inc/Slider'
import { Contactform } from './Contactform'
import "./Home.css"
import Products from './Products'
import SliderButton  from './SliderButton'
import Youtubevideo from './Youtubevidoe';
import License from './License';
import GoogleMap from './GoogleMap';
function Home() {
    const phoneNumber = "918016683916"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918016683916}?text=${encodedMessage}`;
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />

      <br />

      
      <ScrollToTop smooth top="100" color="maroon" />

      <div className="dreamprojectnovestagroup">


        <div className="col-md-12">
          <Slider />


        </div>
      </div>
      <SliderButton/>
      <div className='aqua'>
        <div className="album py-0">
          <div className="container">

            <marquee>

              <h5 style={{ color: "#f0faff" }} className='mt-2'>Welcome to Aqua Dimon RO System | Aqua Dimon RO System is committed to providing advanced and reliable water purification solutions designed to deliver pure, safe, and hygienic water. With modern RO technology, high-quality filtration systems, and durable components, we provide efficient water treatment solutions for homes, offices, commercial establishments, hospitals, and industrial applications. 
              </h5>
            </marquee>
          </div>
        </div>
      </div>

        
<br/>
     
      <center>

        <a href="tel: 8016683916"  class="highlight-btn">
          Book Our Products <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
            <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
          </svg>
        </a>

      </center>
      <br />

      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "5px" }} className="fixed-bottom  mb-1">
        <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
          <button className='whatsAppicon highlight-btn2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
          </button>
        </a>
      </div>
      <div className="album py-2">
        <div className="container">
          <center>
            <h2 style={{ color: "#042c68" }}>AQUA DIMON RO SYSTEM</h2>
            <p>Best Products Available, Premium Produccts Available</p>

            <h1 style={{ color: "#1a7593" }}><b>Products</b></h1>
          </center>
        </div>
      </div>
      <Products/>
      <div className='dimonro'>
  <br/>
    <div className="album py-1">
        <div className="container">
            <center>
            <h2 style={{ color: "#19514f" }}>Aqua Dimon RO System-Youtube</h2>
            <p>Welcome to Aqua Dimon RO System, your trusted destination for reliable RO Water Purifiers, Water Treatment Plants, RO Installation, Repair & Maintenance Services.

Aqua Dimon provides water purification solutions for homes, offices, commercial establishments and industrial requirements. The company is based in Berhampore, Murshidabad, West Bengal.</p>

          </center>
          </div>
        </div>
        <Youtubevideo/>
        <br/>
       </div>
       <br/>
           <div className="album py-0">
        <div className="container">
          <h2><b>Our Happy Client</b></h2>
          </div>
          </div>
            
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1625162562369021%2F&show_text=false&width=357&t=0" width="100%" height="516"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
            </div>
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2600582130411804%2F&show_text=true&width=357&t=0" width="100%" height="521" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

            </div>
          </div>
        </div>
      </div>
      <br/>
      <hr/>

       <div className='dimonrosystem'>
  <br/>
    <div className="album py-1">
        <div className="container">
            <center>
            <h1 className='mb-3' style={{ color: "#19514f" }}>Licensing <b style={{color:"#7c7878"}}>Services</b></h1>


          </center>
          </div>
        </div>
       <License/>
        <br/>
       </div>
<br/>
       <GoogleMap/>
       <br/>
    </div>
  )
}

export default Home